module.exports = __webpack_public_path__ + "img/leader-1.ffd227a8.png";